import moveModals from '../globals/move-modals';
import moveTags from '../globals/move-tags';
import {floatLabels, errorTabIndex} from '../globals/forms';
import {setVarsOnResize} from '../globals/height';
import preventOverflow from '../globals/prevent-overflow';
import resizeListener from '../util/resize';
import scrollListener from '../util/scroll';

resizeListener();
scrollListener();

window.addEventListener('load', () => {
  setVarsOnResize();
  floatLabels(document);
  errorTabIndex(document);
  moveModals(document);
  moveTags(document);
  preventOverflow(document);
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  floatLabels(container);
  errorTabIndex(container);
  moveModals(container);
  moveTags(container);
  preventOverflow(container);
});

document.addEventListener('shopify:section:reorder', () => {
  document.dispatchEvent(new CustomEvent('header:check', {bubbles: false}));
});
